import React from 'react';
import classNames from 'classnames';

import { AcademyModuleTypeSelect } from 'features/moduleManagement';
import styles from './AddMenteeModuleModalField.module.scss';
import Switch from 'components/Switch';

const AddMenteeModuleModalField = ({
  selectedMenteeModule,
  interviewRequired,
  handleInterviewRequired,
  moduleType,
  handleModuleTypeChange,
  skillContest,
  handleSkillContestChange,
}) => {
  return (
    <div className={styles.maindiv}>
      <div className={styles.superbatch}>
        <span className="bold dark">Selected Module Name: </span>
        <span className="m-t-2">
          {selectedMenteeModule?.['academy_module']?.name}
        </span>
      </div>
      <div className={styles.toggle}>
        <span className="bold dark">Mock Interview: </span>
        <Switch
          checked={Boolean(interviewRequired)}
          onChange={handleInterviewRequired}
          className="m-l-xs"
          small
        />
        <span className="m-l-10">
          {Boolean(interviewRequired) ? '(Required)' : '(Not Required)'}
        </span>
      </div>
      <div className={styles.toggle}>
        <span className="bold dark">Skill Contest: </span>
        <Switch
          checked={Boolean(skillContest)}
          onChange={handleSkillContestChange}
          className="m-l-xs"
          small
        />
        <span className="m-l-10">
          {Boolean(skillContest) ? '(Required)' : '(Not Required)'}
        </span>
      </div>
      <div className={styles.superbatch}>
        <span className="bold dark">
          Module To Add:<span className="danger">*</span>
        </span>
        <div className={styles.wrapper}>
          <div className={styles.selectWrapper}>
            <AcademyModuleTypeSelect
              value={moduleType}
              onChange={handleModuleTypeChange}
              className={classNames(styles.input, 'm-r-xs')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMenteeModuleModalField;
